<template>
  <div class="feature-lists feature-lists-detail">
    <FoldSection title="Sites visited" :expand="true">
      <ul class="feature-list feature-list-detail">
        <li
          v-for="(site, index) in tour.sitesVisited"
          v-bind:key="index"
          class="list-detail-content"
        >
          <div class="site-icon">
            <img
              :data-src="VisitedIcon"
              class="visited-icon lazyload"
            />
          </div>
          <div class="site-text">
            {{ site }}
          </div>
        </li>
      </ul>
    </FoldSection>
    <FoldSection title="Included">
      <ul class="feature-list feature-list-detail">
        <li
          v-for="(include, index) in tour.tourIncludes"
          v-bind:key="index"
          class="list-detail-content"
        >
          <div class="site-icon">
            <img
              :data-src="IncludedIcon"
              class="included-icon lazyload"
            />
          </div>
          <div class="site-text">
            {{ include }}
          </div>
        </li>
      </ul>
    </FoldSection>
  </div>
</template>

<script>
import VisitedIcon from "@/static/visited-icon.svg"
import IncludedIcon from "@/static/included-icon.svg"
import FoldSection from "@/components/containers/FoldSection"
export default {
  name: 'SitesVisitedIncluded',
  components: {
    FoldSection
  },
  props: {
    tour: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      VisitedIcon: VisitedIcon,
      IncludedIcon: IncludedIcon
    };
  },
}
</script>

<style lang="scss" scoped>
.feature-lists{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  @include max-width($mobile) {
    display: flex;
    gap: 4px;
    flex-direction: column;
    .feature-list{
      width: 100%;
    }
  }
  &.feature-lists-detail {
    // margin-bottom: 30px;
  }
}


</style>